<template>
	<div>
		<div class="row">
			<div class="col-md-12 pl-0">
				<el-card class="box-card col-md-12 mb-4">
                    <div slot="header" class="clearfix">
                        <strong><span>Auto Care Report</span></strong>
                    </div>
                    <div style="margin:0px 0px;">
                       
                    </div>
                </el-card>
			</div>
		</div>
	</div>
</template>

<script>
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Fuel from '@/components/page/Fuel.js'
import Footer from '@/views/Footer.vue'
import PieChart from '@/components/chart/Pie.js'
import { Config,Penanggalan,AxiosWithJar, FuelColor, Rainbow, Rainbow2 } from '@/utility.js'

export default{
	extends: Fuel,
	components:{
		//ListItem,
		//ListCompare,
		//BarCard,
		//PieChart,
		//Footer            
	},
	data(){
		return {
            value: 0,
		}
	},
	watch: {

	}, 
	computed:{

	},

    mounted(){
		this.$emit('childrenRoute');
    },
    methods:{

	}
}
</script>